export default "__VITE_PUBLIC_ASSET__1b554155__"